import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Users, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { API_URL as API } from '@/utils/apiConfig';


import { useTranslation } from 'react-i18next';


export default function JoinPlanPage() {
  const {
    t
  } = useTranslation();

  const { linkCode } = useParams();
  const navigate = useNavigate();
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolve = async () => {
      try {
        const res = await axios.get(`${API}/share-plan/resolve-link/${linkCode}`);
        setOwner(res.data);
      } catch {
        setError('This invite link is invalid or has expired.');
      } finally {
        setLoading(false);
      }
    };
    resolve();
  }, [linkCode]);

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center" style={{ background: '#0f172a' }}>
        <Loader2 className="h-8 w-8 animate-spin text-indigo-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-dvh flex flex-col items-center justify-center text-center p-6" style={{ background: '#0f172a', color: '#f1f5f9' }}>
        <h1 className="text-2xl font-bold mb-3">{t('generated.joinplanpage_invalid_link_5071')}</h1>
        <p className="text-slate-400 mb-6">{error}</p>
        <Button onClick={() => navigate('/')} className="rounded-full">{t('generated.joinplanpage_go_to_eili_0e2d')}</Button>
      </div>
    );
  }

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center text-center p-6" style={{ background: '#0f172a', color: '#f1f5f9' }}>
      <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ background: '#10b98122' }}>
        <Users className="h-8 w-8" style={{ color: '#10b981' }} />
      </div>
      <h1 className="text-2xl font-bold mb-2">{t('generated.joinplanpage_share_plan_invite_b1e2')}</h1>
      <p className="text-slate-400 mb-1">
        <strong className="text-white">{owner.owner_name}</strong> {t('generated.joinplanpage_has_invited_you_7756')}
      </p>
      <p className="text-sm text-slate-500 mb-8 max-w-sm">
        {t('generated.joinplanpage_sign_in_with_ce97')}
      </p>
      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Button
          onClick={() => navigate('/login')}
          className="w-full rounded-xl py-5 font-medium"
          style={{ background: '#10b981', color: '#fff' }}
          data-testid="join-sign-in-btn"
        >
          {t('generated.joinplanpage_sign_in_e3ed')}
        </Button>
        <Button
          onClick={() => navigate('/signup')}
          variant="outline"
          className="w-full rounded-xl py-5 font-medium"
          style={{ borderColor: '#334155', color: '#f1f5f9' }}
          data-testid="join-create-account-btn"
        >
          {t('generated.joinplanpage_create_account_594d')}
        </Button>
      </div>
    </div>
  );
}
